export const TABLE = "Metadata";
export const PK = "system";
export const RK = "platform";

export type ComponentState = "managed" | "external";
export interface ImageStampEntry { tag: string; digest: string; state: ComponentState }
export interface PersonaStampEntry { treeSha: string; foundryVersion: string }
export interface InstalledStamp {
  schemaVersion: 1;
  platformVersion: string;
  previousPlatformVersion: string | null;
  updatedAt: string;
  lastResult: "success" | "partial" | "failed";
  cli: string;
  components: {
    gateway: ImageStampEntry;
    codingAgent: ImageStampEntry;
    azureExecutor: ImageStampEntry;
    personas: Record<string, PersonaStampEntry>;
    infra: { treeSha: string };
    /** Additive (F05): coarse install-level record of the last seed-delivery pass.
     *  Absent on pre-F05 stamps. The per-repo `.m8t/seed-manifest.json` markers are
     *  authoritative — this only gates drift detection + status display. */
    brainSeeds?: { seedRev: string };
  };
  lastError?: { component: string; message: string };
}

export function stampToEntity(s: InstalledStamp): Record<string, unknown> {
  return {
    partitionKey: PK,
    rowKey: RK,
    platformVersion: s.platformVersion,
    updatedAt: s.updatedAt,
    lastResult: s.lastResult,
    value: JSON.stringify(s),
  };
}

export function entityToStamp(e: Record<string, unknown>): InstalledStamp | null {
  const raw = e.value;
  if (typeof raw !== "string") return null;
  try {
    return JSON.parse(raw) as InstalledStamp;
  } catch {
    return null;
  }
}
